if (!window.Eurus.loadedScript.has('flexible-area.js')) {
    window.Eurus.loadedScript.add('flexible-area.js');
  
    requestAnimationFrame(() => {
      document.addEventListener('alpine:init', () => {
        Alpine.data('xFlexibleArea', () => ({
          initArea(el) {
            if (el.dataset.layout === 'column') return;
            this.adjustFlexWidths(el);

            let resizeTimer;
            window.addEventListener('resize', () => {
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(() => {
                this.adjustFlexWidths(el);
              }, 50);
            });
          },

          adjustFlexWidths(container) {
            const isMobile = window.innerWidth <= 767;

            const items = Array.from(container.children).map(el => {
              const itemBlock = el.querySelector('.item-block');
              const rawWidth = itemBlock
                ? (isMobile ? itemBlock.dataset.widthMobile : itemBlock.dataset.width)
                : '100';
              const isFit = rawWidth === 'fit';
              const itemWidth = isFit ? 0 : (parseFloat(rawWidth) || 100);
              if (isFit) {
                el.style.flex = '0 0 auto';
                el.style.width = 'fit-content';
                el.style.maxWidth = '100%';
              }
              return { el, itemWidth, isFit };
            });

            const style = getComputedStyle(container);
            const gap = parseFloat(style.columnGap || style.gap || 0);
            const containerWidth = container.getBoundingClientRect().width || 1;

            let currentRow = [];
            let currentTotal = 0;

            items.forEach((item) => {
              const added = item.isFit
                ? (item.el.getBoundingClientRect().width / containerWidth) * 100
                : item.itemWidth;
              if (currentRow.length && currentTotal + added > 100.5) {
                this.applyRowWidths(currentRow, gap, containerWidth);
                currentRow = [item];
                currentTotal = added;
              } else {
                currentRow.push(item);
                currentTotal += added;
              }
            });

            this.applyRowWidths(currentRow, gap, containerWidth);
          },

          applyRowWidths(row, gap, containerWidth) {
            if (!row.length) return;

            const totalGap = gap * (row.length - 1);
            const usableWidth = 100 - (totalGap / containerWidth) * 100;

            row.forEach(({ el, itemWidth, isFit }) => {
              if (isFit) {
                el.style.flex = '0 0 auto';
                el.style.width = 'fit-content';
                el.style.maxWidth = '100%';
                return;
              }
              el.style.width = '';
              el.style.maxWidth = '';
              el.style.flex = `0 0 ${usableWidth * (itemWidth / 100)}%`;
            });
          }
        }));
      });
    });
  }